import { metricKeys, metricCategory } from '@pulse/metrics';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';

// metric columns for dimension tables when metric filter is applied
export const METRIC_SPECIFIC_DIMENSION_MAPPING = {
  // [metricKeys.VideoStartFailures]: [metricKeys.VideoStartFailures],
  //  [metricKeys.VideoStartFailuresTech]: [metricKeys.VideoStartFailuresTech],
  //  [metricKeys.VideoStartFailuresBusiness]: [metricKeys.VideoStartFailuresBusiness],
  //  [metricKeys.ExitBeforeVideoStarts]: [metricKeys.ExitBeforeVideoStarts],
  //  [metricKeys.VideoPlaybackFailures]: [metricKeys.VideoPlaybackFailures],
  //  [metricKeys.VideoPlaybackFailuresTech]: [metricKeys.VideoPlaybackFailuresTech],
  //  [metricKeys.VideoPlaybackFailuresBusiness]: [metricKeys.VideoPlaybackFailuresBusiness],
  //  [metricKeys.ExitsDuringPreRoll]: [metricKeys.ExitsDuringPreRoll],
  [metricKeys.VideoStartTime]: [metricKeys.Plays, metricKeys.UniqueDevicesWithAttempts],
  [metricKeys.LifeJoinedAvgBitrate]: [metricKeys.EndedPlays, metricKeys.UniqueDevices],
  // For App
  [metricKeys.AppAvgPageLoadTime]: [metricKeys.AppPageLoadComplete, metricKeys.AppUniqueDevices],
  [metricKeys.AppAvgScreenLoadTime]: [metricKeys.AppScreenLoads, metricKeys.AppUniqueDevices],
  [metricKeys.AppStartupTime]: [metricKeys.AppStartupCount, metricKeys.AppUniqueDevices],
  [metricKeys.AverageMinutesPerPage]: [metricKeys.AppPageLoads, metricKeys.AppUniqueDevices],
  [metricKeys.TimeToFirstAttempt]: [metricKeys.AppSessions, metricKeys.AppUniqueDevices],
  [metricKeys.AverageRequestDuration]: [
    metricKeys.AverageRequestCount,
    metricKeys.AppUniqueDevices,
  ],
};

// metric columns for dimension tables when metric filter is applied
export const METRIC_DIMENSION_MAPPING = {
  [metricCategory[CURRENT_PRODUCT_MODE].STARTUP]: [
    metricKeys.Attempts,
    metricKeys.UniqueDevicesWithAttempts,
  ],
  [metricCategory[CURRENT_PRODUCT_MODE].PLAYBACK]: [
    metricKeys.EndedPlays,
    metricKeys.UniqueDevices,
  ],
  [metricCategory[CURRENT_PRODUCT_MODE].ENGAGEMENT]: [
    metricKeys.EndedPlays,
    metricKeys.UniqueDevices,
  ],
  [metricCategory[CURRENT_PRODUCT_MODE].SP]: [metricKeys.Attempts],
};

//Global sort by values for dimension tables when metric filter is applied
export const METRIC_DIMENSION_GLOBAL_SORT_BY_MAPPING = {
  [metricKeys.RebufferingRatio]: metricKeys.EndedPlays,
  [metricKeys.ConnectionInducedRebufferingRatio]: metricKeys.EndedPlays,
  [metricKeys.Bitrate]: metricKeys.EndedPlays,
  [metricKeys.Framerate]: metricKeys.EndedPlays,
  [metricKeys.VideoRestartTime]: metricKeys.EndedPlays,
  [metricKeys.Minutes]: metricKeys.EndedPlays,
  [metricKeys.PercentageComplete]: metricKeys.EndedPlays,
  [metricKeys.VideoStartTime]: metricKeys.Plays,
  [metricKeys.NonZeroCIRREndedPlays]: metricKeys.EndedPlays,
  [metricKeys.PausedRatio]: metricKeys.EndedPlays,
  [metricKeys.PausedTime]: metricKeys.EndedPlays,
  [metricKeys.LifeAvgNumBitrateSwitches]: metricKeys.EndedPlays,
  [metricKeys.LifeJoinedAvgBitrate]: metricKeys.EndedPlays,
  [metricKeys.VideoStartFailures]: metricKeys.Attempts,
  [metricKeys.VideoStartFailuresTech]: metricKeys.Attempts,
  [metricKeys.VideoStartFailuresBusiness]: metricKeys.Attempts,
  [metricKeys.ExitBeforeVideoStarts]: metricKeys.Attempts,
  [metricKeys.VideoPlaybackFailures]: metricKeys.EndedPlays,
  [metricKeys.VideoPlaybackFailuresTech]: metricKeys.EndedPlays,
  [metricKeys.VideoPlaybackFailuresBusiness]: metricKeys.EndedPlays,
  [metricKeys.ExitsDuringPreRoll]: metricKeys.Attempts,
  [metricKeys.ExitDueToCIR]: metricKeys.EndedPlays,
  [metricKeys.BadSession]: metricKeys.SpiStreams,
  [metricKeys.LifeDropFrameRatio]: metricKeys.EndedPlays,
};
